// extracted by mini-css-extract-plugin
export default {"container":"Activities_container__UCxo1"};